import i18nVue from '@/i18n/locale'
import { get } from 'lodash-es'
import { getBDCountry } from '@/common/utils/i18n'
import { MONETARY_UNIT } from '@/pages-v2/ShopDetail/config/marketCalculator'

export default state => {
  const {
    dishCount, // 菜品数量
    isBusinessGuanajuato, // 是否为瓜纳华托州商家
    isRfcValid, // 是否RFC有效
    paymentMethod, // 付款方式
    platCommissionRate, // 平台佣金率
    platProportionSubsidies, // 平台补贴占比
    dishesCost, // 菜品成本
    platformPrice, // 平台单价
    taxEntity, // 税务主体
    totalDiscount, // 总折扣
    vatRate, // 增值税税率
  } = get(state, 'paymentCalculator', {})
  let margins
  const totalPriceDishes = platformPrice * dishCount // 菜品总价
  const totalDiscountAmount = (totalPriceDishes * totalDiscount) / 100 // 总折扣金额
  const priceActuallyPaidUsers = totalPriceDishes - totalDiscountAmount // 用户实付价格
  const platformSubsidyAmount = totalPriceDishes * (platProportionSubsidies / 100) // 平台补贴金额
  const amountInvestedMerchant =
    totalPriceDishes * ((totalDiscount - platProportionSubsidies) / 100) // 商家投入金额
  const platformCommission =
    (totalPriceDishes - amountInvestedMerchant) * (platCommissionRate / 100) // 平台佣金
  const taxableBasisPayments = (totalPriceDishes - amountInvestedMerchant) / 1.16 // 电子支付的应税基数

  // 统一税务计算变量
  // VAT税率：RFC有效时8%，MX国家16%，其他国家36%
  let calculatedVatRate
  if (isRfcValid === 1) {
    calculatedVatRate = 8 / 100
  } else if (getBDCountry() === 'MX') {
    calculatedVatRate = 16 / 100
  } else {
    calculatedVatRate = 36 / 100
  }
  const vatAmount = taxableBasisPayments * calculatedVatRate // VAT金额（公司和个人共用）
  const isrAmount = taxableBasisPayments * (isRfcValid === 1 ? 2.5 / 100 : 20 / 100) // ISR金额（公司和个人共用）
  const guanajuatoTaxAmount =
    isBusinessGuanajuato === 1 ? (taxableBasisPayments / 1.16) * (1 / 100) : 0 // 瓜纳华托州Cedular税金额

  // 应收金额计算（根据付款方式采用不同规则）
  let amountReceivable
  if (paymentMethod !== 1) {
    // 现金支付场景
    // 现金支付规则：应收金额 = 用户实付价格 + 平台补贴金额 - 平台佣金 - 增值税
    amountReceivable =
      Number((priceActuallyPaidUsers + platformSubsidyAmount).toFixed(state.currencyPrecision)) -
      Number(platformCommission.toFixed(state.currencyPrecision)) -
      Number((platformCommission * (vatRate / 100)).toFixed(state.currencyPrecision)) // 现金支付应收金额
  } else {
    // 电子支付场景
    // 电子支付规则：包含完整税费扣除
    amountReceivable =
      Number((priceActuallyPaidUsers + platformSubsidyAmount).toFixed(state.currencyPrecision)) -
      Number(platformCommission.toFixed(state.currencyPrecision)) -
      Number((platformCommission * (vatRate / 100)).toFixed(state.currencyPrecision)) -
      Number(vatAmount.toFixed(state.currencyPrecision)) -
      Number(isrAmount.toFixed(state.currencyPrecision)) -
      Number(guanajuatoTaxAmount.toFixed(state.currencyPrecision)) // 电子支付应收金额
  }
  const mxShow = taxEntity === 1 && paymentMethod === 1 && getBDCountry() === 'MX' // MX output（个人电子支付）
  const companyElectronicPayment = paymentMethod === 1 && taxEntity === 2 // 公司电子支付
  // 仅电子支付场景才需要额外计算个人应收金额，现金支付直接使用amountReceivable
  const personsAmountReceivable = mxShow
    ? Number(amountReceivable.toFixed(state.currencyPrecision))
    : amountReceivable
  // 利润
  if (dishesCost) {
    if (mxShow) {
      // 墨西哥个人
      margins = personsAmountReceivable - dishesCost
    } else {
      // 墨西哥公司 ｜ 非墨西哥
      margins = amountReceivable - dishesCost
    }
  } else {
    if (mxShow) {
      // 墨西哥个人
      margins = personsAmountReceivable
    } else {
      // 墨西哥公司 ｜ 非墨西哥
      margins = amountReceivable
    }
  }
  return [
    {
      title: i18nVue.t('FoodB_calculator_cctL_sltb' /** 菜品总价 */),
      value: totalPriceDishes,
      symbol: MONETARY_UNIT[getBDCountry()] || '$',
    },
    {
      title: i18nVue.t('FoodB_calculator_vEpj_lLGl' /** 总折扣 */),
      value: totalDiscount * 1,
      symbol: '%',
      children: [
        {
          show: true,
          title: i18nVue.t('FoodB_calculator_QGtY_JOsw' /** 商家投入折扣的部分 */),
          value: totalDiscount - platProportionSubsidies,
        },
        {
          show: true,
          title: i18nVue.t('FoodB_calculator_HfHr_bkLf' /** 平台补贴折扣的部分 */),
          value: platProportionSubsidies,
        },
      ],
    },
    {
      symbol: MONETARY_UNIT[getBDCountry()] || '$',
      title: i18nVue.t('FoodB_calculator_mTaD_pjZv' /** 总折扣金额 */),
      value: totalDiscountAmount,
      children: [
        {
          show: true,
          title: i18nVue.t('FoodB_calculator_TJJY_SkoH' /** 商家投入金额 */),
          value: amountInvestedMerchant,
        },
        {
          show: true,
          title: i18nVue.t('FoodB_calculator_GdDU_bFgc' /** 平台补贴金额 */),
          value: platformSubsidyAmount,
        },
      ],
    },
    {
      symbol: MONETARY_UNIT[getBDCountry()] || '$',
      title: i18nVue.t('FoodB_calculator_JGZb_tQiY' /** 用户实付价格 */),
      value: priceActuallyPaidUsers,
    },
    {
      symbol: MONETARY_UNIT[getBDCountry()] || '$',
      title: i18nVue.t('FoodB_calculator_dsiQ_vhFJ' /** 应收金额 */),
      value: mxShow ? personsAmountReceivable : amountReceivable,
      children: [
        {
          show: true,
          value: priceActuallyPaidUsers + platformSubsidyAmount,
          title: i18nVue.t('FoodB_calculator_CXvv_RJgQ' /** 税和佣金前的应收金额 */),
        },
        {
          show: true,
          value: platformCommission,
          title: i18nVue.t('FoodB_calculator_BKfQ_ehtA' /** 平台佣金 */),
        },
        {
          show: true,
          value: platformCommission * (vatRate / 100),
          title:
            getBDCountry() === 'PE' // 目前PE国家不支持es-419 暂时先用es-mx
              ? i18nVue.t('FoodB_IGV_WGYF_kfvV' /** 增值税 */)
              : i18nVue.t('FoodB_calculator_ydSg_ejbp' /** 增值税 */),
        },
        {
          show: mxShow,
          value: taxableBasisPayments,
          title: i18nVue.t('FoodB_calculator_WKKD_DbHM' /** 电子支付的应税基数 */),
        },
        {
          show: companyElectronicPayment, // 公司电子支付
          value: taxableBasisPayments,
          title: i18nVue.t('FoodB_calculator_WKKD_DbHM' /** 电子支付的应税金额 */),
        },
        {
          show: companyElectronicPayment, // 公司电子支付
          value: vatAmount,
          title: i18nVue.t('FoodB_Tax_yLfJ_CAbz' /** 公司VAT金额 */),
        },
        {
          show: companyElectronicPayment, // 公司电子支付
          value: isrAmount,
          title: i18nVue.t('FoodB_Tax_nKEQ_EIAC' /** 公司ISR金额 */),
        },
        {
          show: companyElectronicPayment && isBusinessGuanajuato === 1, // 公司电子支付且是瓜纳华托州商家
          value: guanajuatoTaxAmount,
          title: i18nVue.t('FoodB_calculator_hPAw_BZlP' /** 瓜纳华托州Cedular税金额 */),
        },
        {
          show: mxShow,
          value: vatAmount,
          title: i18nVue.t('FoodB_calculator_AioF_coBc' /** 个人VAT金额 */),
        },
        {
          show: mxShow,
          value: isrAmount,
          title: i18nVue.t('FoodB_calculator_HXix_qhAK' /** 个人ISR金额 */),
        },
        {
          show: mxShow && isBusinessGuanajuato === 1,
          value: guanajuatoTaxAmount,
          title: i18nVue.t('FoodB_calculator_hPAw_BZlP' /** 瓜纳华托州Cedular税金额 */),
        },
      ],
    },
    {
      symbol: MONETARY_UNIT[getBDCountry()] || '$',
      title: i18nVue.t('FoodB_calculator_VujK_GJbV' /** 利润 */),
      value: margins,
    },
    {
      symbol: '%',
      title: i18nVue.t('FoodB_calculator_gRHL_Sgok' /** 利润率 */),
      value: margins ? ((margins / priceActuallyPaidUsers) * 100).toFixed(2) : margins,
    },
  ]
}
